import addGame from "./addGame";
import iterate from "./iterate";

export default {
	addGame,
	iterate,
};
